import {KeyboardSensor, PointerSensor, useSensor, useSensors} from '@dnd-kit/core';
import {sortableKeyboardCoordinates} from '@dnd-kit/sortable';

export const useDefaultDndSensors = () => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 10,
      },
    }),
    // Keyboard path for drag handles: Space/Enter picks the item up, arrow keys move it,
    // Space/Enter drops it, Escape cancels.
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  return sensors;
};
